import React, {Component} from 'react';
import { connect } from 'react-redux';
import ribbon from '../../../FO/resources/img/ribbon.png';
import ribbonActive from '../../../FO/resources/img/ribbon-active.png';
import { addFestivalToFavorite, removeFestivalFromFavorite } from '../../actions/festival.actions'; 
import { 
    addMovieToFavoriteFromAllMovies, 
    removeMovieFromFavoriteFromAllMovies,
    addMovieToFavoriteFromRecentMovies,
    removeMovieFromFavoriteFromRecentMovies,
    addMovieToFavoriteFromHomeRecentMovies,
    removeMovieFromFavoriteFromHomeRecentMovies,
    addMovieToFavoriteFromRecommended,
    removeMovieFromFavoriteFromRecommended,
    addMovieToFavoriteFromSoonInCinema,
    removeMovieFromFavoriteFromSoonInCinema
} from '../../actions/movies.actions';
import {addMovieToFavorite, removeMovieFromFavorite, addArticleToFavorite, removeArticleFromFavorite} from '../../actions/searchresults.actions';
import { withRouter } from 'react-router';
import { addCinemaToFavorite, removeCinemaFromFavorite } from '../../actions/movietheaters.actions';

import {LOGIN_ROUTE} from "../../config/routes";

class Favorite extends Component {

    constructor(props) {
        super(props);
        this.state = {
            favorite_length: this.props.favorite ? this.props.favorite.length: 0,
            component: this.props.component
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.favorite_length !== nextProps.favorite.length){
            this.setState({favorite_length: nextProps.favorite.length})
        }
    }

    addToFavorite = () => {
        switch(this.props.type) {
            case "allMovies":
                this.props.addMovieToFavoriteFromAllMovies(this.props.id);
                this.setState({favorite_length: 1}); 
                break;
            case "recentMovies":
                this.props.addMovieToFavoriteFromRecentMovies(this.props.id);
                this.setState({favorite_length:1})
                break;
            case "festival":
                this.props.addFestivalToFavorite(this.props.id);
                this.setState({favorite_length: 1}); 
                break;
            case "recentsoonmovies":
                this.props.addMovieToFavoriteFromHomeRecentMovies({film_id: this.props.id, view: this.props.view});
                this.setState({favorite_length: 1});
                break;
            case "recommended":
                this.props.addMovieToFavoriteFromRecommended(this.props.id);
                this.setState({favorite_length: 1});
                break;
            case "soon-in-cinema":
                this.props.addMovieToFavoriteFromSoonInCinema(this.props.id);
                this.setState({favorite_length: 1});
                break;
            case "searchresultsmovies":
                this.props.addMovieToFavorite(this.props.id);
                this.setState({favorite_length: 1});
                break;
            case "searchresultsarticles":
                this.props.addArticleToFavorite(this.props.id);
                this.setState({favorite_length: 1});
                break;
            case "cinema":
                this.props.addCinemaToFavorite(this.props.id);
                this.setState({favorite_length: 1});
                break;
            default: 
                break;
        }
    }

    removeFromFavorite = () => {
        switch(this.props.type) {
            case "allMovies":
                this.props.removeMovieFromFavoriteFromAllMovies(this.props.id, this.props.favorite[0].uuid)
                this.setState({favorite_length: 0});
                break;
            case "recentMovies":
                this.props.removeMovieFromFavoriteFromRecentMovies(this.props.id, this.props.favorite[0].uuid)
                this.setState({favorite_length:0});
                break;
            case "festival":
                this.props.removeFestivalFromFavorite(this.props.id, this.props.favorite[0].uuid);   
                this.setState({favorite_length: 0});
                break;  
            case "recentsoonmovies":
                this.props.removeMovieFromFavoriteFromHomeRecentMovies({uuid: this.props.favorite[0].uuid, film_uuid: this.props.id, view: this.props.view});
                this.setState({ favorite_length: 0});
                break;    
            case "recommended" :
                this.props.removeMovieFromFavoriteFromRecommended({uuid: this.props.favorite[0].uuid, film_uuid: this.props.id});
                this.setState({ favorite_length: 0});
                break;
            case "soon-in-cinema":
                this.props.removeMovieFromFavoriteFromSoonInCinema({uuid: this.props.favorite[0].uuid, film_uuid: this.props.id})
                this.setState({favorite_length: 0});
                break;
            case "searchresultsmovies":
                this.props.removeMovieFromFavorite({uuid: this.props.favorite[0].uuid, film_uuid: this.props.id});
                this.setState({favorite_length: 0});
                break;
            case "searchresultsarticles":
                this.props.removeArticleFromFavorite({uuid: this.props.favorite[0].uuid, article_uuid: this.props.id});
                this.setState({favorite_length: 0});
                break;
            case "cinema":
                this.props.removeCinemaFromFavorite({uuid: this.props.favorite[0].uuid, cinema_uuid: this.props.id});
                this.setState({favorite_length: 0});
                break;
            default: 
                break;
        }
    }

    goToLogin = () => {
        this.props.history.push(LOGIN_ROUTE)
    };

    isItemFavorite = () => {
        if (localStorage.getItem('login_type') === "authenticated"){
            return this.state.favorite_length === 0 ? 
            <div className={this.state.component === 'list' ? 'favorite-list' : 'favorite-carousel'}>
                <img alt={'Favorite'} src={ribbon} onClick={this.addToFavorite} />            
            </div> :
            <div className={this.state.component === 'list' ? 'favorite-list' : 'favorite-carousel'}>
                <img alt={'Favorite'} src={ribbonActive} onClick={this.removeFromFavorite} />            
            </div>
        } else {
            return  (
                <div className={this.state.component === 'list' ? 'favorite-list' : 'favorite-carousel'}>
                    <img alt={'Favorite'} src={ribbon} onClick={this.goToLogin} />
                </div>
            )
        }
    }

    render() {
        return (
            <div className="favorite">
               {this.isItemFavorite()} 
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default withRouter(connect(mapStateToProps, {
        addFestivalToFavorite, 
        removeFestivalFromFavorite, 
        addMovieToFavoriteFromAllMovies, 
        removeMovieFromFavoriteFromAllMovies,
        addMovieToFavoriteFromRecentMovies,
        removeMovieFromFavoriteFromRecentMovies,
        addMovieToFavoriteFromHomeRecentMovies,
        removeMovieFromFavoriteFromHomeRecentMovies,
        addMovieToFavoriteFromRecommended,
        removeMovieFromFavoriteFromRecommended,
        addMovieToFavoriteFromSoonInCinema,
        removeMovieFromFavoriteFromSoonInCinema,
        addMovieToFavorite,
        removeMovieFromFavorite,
        addArticleToFavorite, 
        removeArticleFromFavorite,
        addCinemaToFavorite,
        removeCinemaFromFavorite
})(Favorite));


// WEBPACK FOOTER //
// ./src/SHARED/components/favorite/favorite.component.js